"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Travel;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Travel(_ref) {
  var {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "66",
    height: "55",
    viewBox: "0 0 66 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group 808"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector",
    d: "M26.7422 4.63495C28.3145 3.31953 30.1306 2.3269 32.0867 1.71385C34.0429 1.1008 36.1006 0.879348 38.1424 1.06214C40.1842 1.24492 42.17 1.82838 43.9861 2.77913C45.8022 3.72989 47.4131 5.02929 48.7267 6.60306C51.3807 9.77953 52.6643 13.8801 52.2952 18.0029C51.9262 22.1257 49.9346 25.933 46.7586 28.5876C45.1857 29.9024 43.369 30.8943 41.4125 31.5065C39.456 32.1187 37.398 32.3392 35.3562 32.1554C33.3144 31.9717 31.3288 31.3872 29.5131 30.4355C27.6973 29.4838 26.0869 28.1835 24.7741 26.609C24.0371 25.7381 23.4014 24.7863 22.8792 23.772C22.7641 23.5521 22.6594 23.3323 22.5547 23.1124",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_2",
    d: "M15.9181 8.28906C13.9581 8.28906 12.0174 8.67527 10.2068 9.42562C8.39615 10.176 6.75112 11.2758 5.36571 12.6621C3.9803 14.0485 2.88166 15.6943 2.13257 17.5055C1.38348 19.3166 0.998628 21.2577 1 23.2176H30.8466C30.8466 19.2583 29.2738 15.4612 26.4741 12.6615C23.6745 9.8619 19.8774 8.28906 15.9181 8.28906",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_3",
    d: "M15.9181 8.28906C13.9581 8.28906 12.0174 8.67527 10.2068 9.42562C8.39615 10.176 6.75112 11.2758 5.36571 12.6621C3.9803 14.0485 2.88166 15.6943 2.13257 17.5055C1.38348 19.3166 0.998628 21.2577 1 23.2176H30.8466C30.8466 19.2583 29.2738 15.4612 26.4741 12.6615C23.6745 9.8619 19.8774 8.28906 15.9181 8.28906V8.28906Z",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_4",
    d: "M15.918 23.2188V43.0153",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_5",
    d: "M15.9186 8.28906C12.3802 8.28906 9.51172 14.9682 9.51172 23.2176H22.3046C22.3046 14.9682 19.4571 8.28906 15.9186 8.28906Z",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_6",
    d: "M64.4192 53.6493C60.0956 45.9547 47.8156 40.4062 33.3268 40.4062C18.8379 40.4062 6.558 45.9547 2.23438 53.6493H64.4192Z",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_7",
    d: "M32 4.00606C32 4.53055 31.8966 5.04991 31.6959 5.53447C31.4952 6.01904 31.2011 6.45933 30.8302 6.8302C30.4593 7.20107 30.019 7.49524 29.5345 7.69595C29.0499 7.89667 28.5305 8 28.006 8C26.9457 8 25.9285 7.5796 25.1776 6.83094C24.4267 6.08228 24.0032 5.06643 24 4.00606C24 2.94358 24.422 1.9246 25.1733 1.17332C25.9246 0.422036 26.9436 0 28.006 0C28.5316 -2.42748e-06 29.0519 0.103685 29.5373 0.305157C30.0226 0.50663 30.4635 0.801904 30.8345 1.17406C31.2055 1.54622 31.4995 1.98793 31.6995 2.4739C31.8995 2.95987 32.0016 3.48055 32 4.00606Z",
    fill: "#54C8E8"
  })));
}